export default __webpack_public_path__ + "static/media/myblog.235a068b.svg";